import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import RiskDisclosure from '../components/RiskDisclosure';

export default function RiskDisclosurePage() {
  return (
    <div className="min-h-screen bg-[#0a0a0b] flex flex-col">
      <Navbar />
      <main className="flex-1">
        <RiskDisclosure />
      </main>
      <Footer />
    </div>
  );
}
